<template>
  <div>
    <!-- <customize /> -->
    <breadcrumbs
      :bc-case-id="bcCaseId"
    />
    <!-- Table Container Card -->
    <b-overlay
      id="overlay-background"
      :show="headerLoader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        no-body
        :class="`pt-1 mb-0 ${getBorder(caseStatus)}`"
      >
        <details-header
          :bc-case-id="bcCaseId"
          :case-status="caseStatus"
          :prefix-case-id="prefixCaseId"
          :case-state-data="caseStateData"
          :case-state="state"
        />
      </b-card>
    </b-overlay>
    <hr>
    <case-modules
      :case-state-data="caseStateData"
    />
    <hr>
    <b-overlay
      id="overlay-background"
      :show="shiftingdragging"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-row>
        <b-col
          sm="12"
          md="7"
          lg="7"
        >
          <dragable-components
            ref="leftsidecustomization"
            side="Right"
            :places="leftSideComponents"
            :bc-case-id="bcCaseId"
          />
        </b-col>
        <b-col
          sm="12"
          md="5"
          lg="5"
        >
          <dragable-components
            ref="rightsidecustomization"
            side="Left"
            :places="rightSideComponents"
            :bc-case-id="bcCaseId"
          />
        </b-col>
      </b-row>
      <terminate-data-modal
        ref="terminateModal"
        :case-data="showData"
        :case-state-title="caseStateTitle"
        :reason-options="reasonOptions"
      />
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BOverlay,
} from 'bootstrap-vue'
// import store from '@/store'
// import { EventBus } from '@/event-bus'
// import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import axios from '@axios'
import { showToast } from '@core/mixins/ui/toastnotification'
// import detailStoreModule from './detailStoreModule'
import Breadcrumbs from './childcomponents/Breadcrumbs.vue'
import DetailsHeader from './childcomponents/DetailsHeader.vue'
import CaseModules from './childcomponents/CaseModules.vue'
import DragableComponents from './dragableComponents.vue'
import TerminateDataModal from './TerminateDataModal.vue'
// import Customize from './childcomponents/Customize.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BOverlay,
    Breadcrumbs,
    DetailsHeader,
    CaseModules,
    DragableComponents,
    TerminateDataModal,
    // Customize,
  },
  // setup() {
  //   const USER_APP_STORE_MODULE_NAME = 'case-details'

  //   // Register module
  //   if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, detailStoreModule)

  //   // UnRegister on leave
  //   onUnmounted(() => {
  //     if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
  //   })
  //   store.dispatch('case-details/fetchDetails', { id: router.currentRoute.params.id })
  //   const {
  //     bcCaseId, customVariables, customVariableAirports, caseStatus,
  //   } = store.state['case-details']
  //   console.log('bcCaseId ', bcCaseId, 'customVariables,', customVariables, 'customVariableAirports ', customVariableAirports, ' caseStatus,', caseStatus)
  //   return {
  //     bcCaseId,
  //     customVariables,
  //     customVariableAirports,
  //     caseStatus,
  //   }
  // },
  directives: {
    Ripple,
  },
  mixins: [showToast],
  data() {
    return {
      shiftingdragging: false,
      headerLoader: false,
      leftSideComponents: [
        {
          custom_widget_id: null,
          data: null,
          id: 1,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 2,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 3,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 4,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 5,
          type: 'default',
        },
      ],
      rightSideComponents: [
        {
          custom_widget_id: null,
          data: null,
          id: 6,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 7,
          type: 'default',
        },
        {
          custom_widget_id: null,
          data: null,
          id: 8,
          type: 'default',
        },
      ],
      initialComponentSettings: [
        {
          area: 'left',
          custom_widget_id: null,
          section_id: 1,
          sort_order: 1,
          type: 'default',
        },
        {
          area: 'left',
          custom_widget_id: null,
          section_id: 2,
          sort_order: 2,
          type: 'default',
        },
        {
          area: 'left',
          custom_widget_id: null,
          section_id: 3,
          sort_order: 3,
          type: 'default',
        },
        {
          area: 'left',
          custom_widget_id: null,
          section_id: 4,
          sort_order: 4,
          type: 'default',
        },
        {
          area: 'left',
          custom_widget_id: null,
          section_id: 5,
          sort_order: 5,
          type: 'default',
        },
        {
          area: 'right',
          custom_widget_id: null,
          section_id: 6,
          sort_order: 1,
          type: 'default',
        },
        {
          area: 'right',
          custom_widget_id: null,
          section_id: 7,
          sort_order: 2,
          type: 'default',
        },
        {
          area: 'right',
          custom_widget_id: null,
          section_id: 8,
          sort_order: 3,
          type: 'default',
        },
      ],
      postedComponents: [],
      caseId: this.$route.params.id,
      bcCaseId: '',
      caseStatus: 0,
      prefixCaseId: '',
      caseStateData: {},
      state: 'n/a',
      showData: {},
      caseStateTitle: '',
      reasonOptions: [],
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // EventBus.$on('shiftDetailsComponent', obj => {
    //   this.shiftFunction(obj)
    // })
    // EventBus.$on('updateWidgetSettingsInParent', () => {
    //   this.saveWidgetSettings()
    // })
    // EventBus.$on('revertWidgetSettingsInParent', () => {
    //   this.revertWidgetSettings()
    // })
    // EventBus.$on('refreshStateData', () => {
    //   this.caseStateInformation()
    //   this.generalCaseInformation()
    // })
    // this.getWidgetSettings()
    this.caseStateInformation()
    // this.getReasonsOptions()
  },
  methods: {
    async getReasonsOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.reasonOptions = response.data.data
        }
      })
    },
    async caseStateInformation() {
      this.headerLoader = true
      const url = `/debt-case/state/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          if (response.data.data !== null && typeof response.data.data !== 'undefined') {
            this.caseStateData = response.data.data
            this.state = response.data.data.state
          } else {
            this.caseStateData.debt_case_id = this.caseId
          }
          this.headerLoader = false
          this.generalCaseInformation()
        }
      })
    },
    async generalCaseInformation() {
      this.headerLoader = true
      const url = `/debt-case/general-info/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.bcCaseId = response.data.data.debt_case.bc_case_id
          this.caseStatus = response.data.data.debt_case.status
          this.prefixCaseId = response.data.data.debt_case.prefix_case_id ? response.data.data.debt_case.prefix_case_id : this.caseId
          // this.getCurrentBaseDocuments(1)
          this.headerLoader = false
          if (this.caseStatus === 2) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'decline')
          } else if (this.caseStatus === 3) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'terminate')
          } else {
            this.isBlur = false
          }
        }
      })
    },
    async getTerminateData(item, state) {
      if (state === 'terminate') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_TERMINATED_BECAUSE')
      }
      if (state === 'decline') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_DECLINED_BECAUSE')
      }
      this.$refs.terminateModal.$children[0].show()
      this.modalLoader = true
      this.showData = { ...item }
      this.modalLoader = false
    },
    getBorder(status) {
      let colorClass = ''
      if (status === null) {
        colorClass = 'case-general-info-red'
      }
      if (status === 0) {
        colorClass = 'case-general-info-blue'
      }
      if (status === 1) {
        colorClass = 'case-general-info-green'
      }
      if (status === 2 || status === 3) {
        colorClass = 'case-general-info-red'
      }
      if (status === 4) {
        colorClass = 'case-general-info-orange'
      }
      return colorClass
    },
    async getWidgetSettings() {
      // this.leftSideComponents = []
      // this.rightSideComponents = []
      // this.initialComponentSettings = []
      // await axios.get(`/debt-case-sections/get?debt_case_id=${router.currentRoute.params.id}`).then(settings => {
      //   if (settings.status) {
      //     const widgets = settings.data.data
      //     widgets.forEach(element => {
      //       const obj = {
      //         type: element.custom_widget_id ? 'custom' : 'default',
      //         id: element.section_id ? element.section_id : element.id,
      //         custom_widget_id: element.custom_widget_id,
      //         data: element.custom_widget_id ? element.custom_widget_def[0] : null,
      //       }
      //       if (element.area === 'left') {
      //         this.leftSideComponents.push(obj)
      //       } else {
      //         this.rightSideComponents.push(obj)
      //       }
      //       const obj2 = {
      //         area: element.area,
      //         section_id: element.section_id ? element.section_id : element.id,
      //         sort_order: element.sort_order,
      //         custom_widget_id: element.custom_widget_id,
      //         type: element.custom_widget_id ? 'custom' : 'default',
      //       }
      //       this.initialComponentSettings.push(obj2)
      //       console.log(' this.leftSideComponents ', this.leftSideComponents)
      //       console.log(' this.rightSideComponents ', this.rightSideComponents)
      //       console.log(' this.initialComponentSettings ', this.initialComponentSettings)
      //     })
      //   }
      // }).catch(() => {
      //   this.failureToast('Widget settings could not be fetched.')
      // })
    },
    compareSides(arr) {
      let isDifferent = false
      this.initialComponentSettings.forEach((element, index) => {
        if (element !== arr[index]) {
          isDifferent = true
        }
      })
      return isDifferent
    },
    saveWidgetSettings() {
      this.leftSideComponents = this.$refs.leftsidecustomization.widgetComponents
      this.rightSideComponents = this.$refs.rightsidecustomization.widgetComponents
      const toBePosted = [...this.leftSideComponents, ...this.rightSideComponents]
      this.getAllSortedComponents(this.leftSideComponents, 'left')
      this.getAllSortedComponents(this.rightSideComponents, 'right')
      if (this.compareSides(toBePosted)) {
        axios.post('/debt-case-sections/update', {
          debt_case_id: Number(router.currentRoute.params.id),
          sections: this.postedComponents,
        }).then(settings => {
          if (settings.status) {
            this.initialComponentSettings = [...toBePosted]
            this.successToast('Changes have been updated.')
          }
        }).catch(() => {
          this.failureToast('Changes could not be updated.')
        })
      } else {
        this.failureToast('No changes detected to be updated.')
      }
      this.postedComponents = []
    },
    revertWidgetSettings() {
      const leftComponenets = this.$refs.leftsidecustomization.widgetComponents
      const rightComponents = this.$refs.rightsidecustomization.widgetComponents
      const components = [...leftComponenets, ...rightComponents]
      if (this.compareSides(components)) {
        this.getWidgetSettings().then(() => {
          this.successToast('Changes have been reverted successfully.')
        })
      } else {
        this.failureToast('No changes detected to be reverted.')
      }
    },
    getAllSortedComponents(arr, area) {
      arr.forEach((element, index) => {
        const obj = {
          section_id: element.id,
          category: element.type,
          sort_order: index + 1,
          custom_widget_id: element.custom_widget_id,
          area,
        }
        this.postedComponents.push(obj)
      })
    },
    shiftFunction(obj) {
      this.shiftingdragging = true
      setTimeout(() => {
        if (obj.side === 'Right') {
          const componentIndex = this.leftSideComponents.findIndex(element => element.id === obj.parent)
          this.rightSideComponents.push(this.leftSideComponents[componentIndex])
          this.leftSideComponents.splice(componentIndex, 1)
        } else {
          const componentIndex = this.rightSideComponents.findIndex(element => element.id === obj.parent)
          this.leftSideComponents.push(this.rightSideComponents[componentIndex])
          this.rightSideComponents.splice(componentIndex, 1)
        }
        this.shiftingdragging = false
      }, 1500)
    },
  },
}
</script>

<style lang="scss">
@import './detailstyling.scss';
.draggable-list .list-group-item {
  transition: all 1s ease;
  padding: 0px;
  background-color: #f6f6f6;
  border: none;
  animation-name: shake;
  animation-duration: .20s;
  animation-iteration-count: infinite;
  &:nth-child(even){
    animation-name: shakeeven;
  }
}
@keyframes shake {
  0% {
    transform: translate3d(-4px, 0, 0);
  }
  50% {
    transform: translate3d(4px, 0, 0);
  }
  100% {
    transform: translate3d(-4px, 0, 0);
  }
}
@keyframes shakeeven {
  0% {
    transform: translate3d(4px, 0, 0);
  }
  50% {
    transform: translate3d(-4px, 0, 0);
  }
  100% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
